import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef, useState } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../../../colorVars';
import { addExitTactic } from '../../../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/addExitTactic';
import { useWebsocketStore } from '../../../../../../../../../../stores/websocketStore/websocketProvider';
import TextButton from '../../../../../../../../../atomic/buttons/textButton/TextButton';
import { EditableTableFieldNoOnBlurUpdate } from '../../../../../../../../../atomic/inputs/editableTableField/EditableFieldNoOnBlurUpdate';
import { Body3, fontSizes } from '../../../../../../../../../atomic/text/Text';
import { positionPriceTrailValidation } from '../../../../../../../../../forms/tradeplans/AddTradePlan/DataValidation';
import { IndividualPanelHeader } from '../../../../individualTacticPanels/IndividualPanelHeader';
import style from './IndividualAddTacticPanel.module.css';

export const AddPositionPriceTrailTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, softOrderId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const [headerText, setHeaderText] = useState('Add Position Price Trail');
    const [headerTextColor, setHeaderTextColor] = useState(colors.lightGrey);
    const [details, setDetails] = useState({
      amount: 0,
    });
    const timeoutRef = useRef(null);

    const addTactic = () => {
      const validationResult = positionPriceTrailValidation(details);
      if (validationResult[0] === false) {
        setHeaderText(validationResult[1]);
        setHeaderTextColor(colors.red);
        const timer = setTimeout(() => {
          setHeaderText('Add Position Price Trail');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      } else {
        addExitTactic(tradePlanId, {
          tactic: 'POSITION_PRICE_TRAIL',
          details,
        });
        setHeaderText('Position Price Trail Added');
        setHeaderTextColor(colors.green);
        const timer = setTimeout(() => {
          setHeaderText('Add Position Price Trail');
          setHeaderTextColor(colors.lightGrey);
        }, 2000);
        timeoutRef.current = timer;
      }
    };

    useEffect(() => {
      return () => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
      };
    }, []);

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            <tbody>
              <tr>
                <td className={style.labelTd}>
                  <Body3 fontWeight={700} color={colors.lightGrey}>
                    Amount
                  </Body3>
                </td>
                <td className={style.inputTd}>
                  <div className={style.inputWrapper}>
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      $
                    </Body3>
                    <EditableTableFieldNoOnBlurUpdate
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      fontSize={fontSizes.body3}
                      value={details.amount}
                      setValue={(newValue) =>
                        setDetails((prev) => ({
                          ...prev,
                          amount: newValue,
                        }))
                      }
                    />
                  </div>
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <header className={style.header}>
            <Body3 color={headerTextColor} fontWeight={700}>
              {headerText}
            </Body3>
            <TextButton
              disabled={tradePlan.exitTactics['POSITION_PRICE_TRAIL']}
              color={colors.lightGrey}
              backgroundColor={
                tradePlan.exitTactics['POSITION_PRICE_TRAIL']
                  ? colors.grey
                  : colors.blue
              }
              fontSize="small"
              clickHandler={addTactic}
              width="20%"
              height="50%"
            >
              Add
            </TextButton>
          </header>
        </div>
      </TabPanel>
    );
  }
);

AddPositionPriceTrailTacticPanel.tabsRole = 'TabPanel';
